<section class="skillsWrap">
    <div class="left-sidebar">
        <app-sidebar></app-sidebar> 
    </div>
    <div class="right-panel educationpage">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <h4 class="pageTitle"> Education </h4>
            <div class="row">
                <div class="col-md-6 col-lg-6 ">
                    <div class="form-group">
                        <label> Degree or Specialization<span class="orangeText">*</span> </label>
                        <select class="form-control" formControlName="specializationId" (ngModelChange)="selectedDegree($event)">
                            <option disabled selected hidden> Please select</option>
                            <option *ngFor="let spec of allSpec;let i =index;" [value]="spec.id"> {{spec.name}}</option>
                        </select>
                        <div class="text-danger" *ngIf="showError && form.controls['specializationId'].hasError('required')">
                            *Please enter Degree or specialization.
                        </div>
                    </div>
                    <div class="form-group" *ngIf="showOtherDegree">
                        <label>Other Degree or Specialization<span class="orangeText">*</span> </label>
                        <input type="text" class="form-control" formControlName="otherTitleSpecialization">
                        <div class="text-danger" *ngIf="showOtherDegree && form.value.otherTitleSpecialization == '' && showError">
                            *Please enter othre Degree or specialization.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 ">
                    <div class="form-group">
                        <label> University or institution<span class="orangeText">*</span> </label>
                        <select class="form-control" formControlName="universityId" (ngModelChange)="selectedUniversity($event)">
                            <option disabled selected="selected" hidden> Please select</option>
                            <option *ngFor="let uni of allUni;let i =index;" [value]="uni.id"> {{uni.name}}</option>
                        </select>
                        <div class="text-danger" *ngIf="form.controls['universityId'].hasError('required') && showError">
                            *Please enter University or institution.
                        </div>
                    </div>
                    
                    <div class="form-group" *ngIf="showOtherUniversity">
                        <label>Other University or institution<span class="orangeText">*</span> </label>
                        <input type="text" class="form-control" formControlName="otherTitleUniveristy">
                        <div class="text-danger" *ngIf="form.controls['otherTitleUniveristy'].hasError('required') && showError">
                            *Please enter othre University or institution.
                        </div>
                    </div>
                </div>
    
                <div class="col-md-6 col-lg-6 ">
                    <div class=" d-flex justify-content-between">
                        <div class="form-group">
                            <label> From </label> 
                            <div id="date-picker-example" class="datepicker">
                                <input type="text" autocomplete="off" class="form-control" placeholder="Enter date" bsDatepicker placement="bottom" [bsValue]="form.value.fromDate" [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }" formControlName="fromDate" [maxDate]="maxDate" id="dateNaiss" (keydown)="onKeyDown($event)">
                                <span class="ic_calendar" for="dateNaiss"><img src="assets/images/ic_calendar.svg"></span>
                            </div>
                            <div class="text-danger" *ngIf="showError == true && form.controls['fromDate'].hasError('required')">*Please select From</div>
                        </div>
    
                        <div class="form-group">
                            <label> To </label>
                            <div id="date-picker-example" class="datepicker">
                                <input type="text" placeholder="Enter date"
                                class="form-control" bsDatepicker
                                [minDate]="form.value.fromDate == '' ? minDate : form.value.fromDate"
                                formControlName="toDate"
                                [maxDate]="maxDate"
                                [bsValue]="form.value.toDate"
                                [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }" (keydown)="onKeyDown($event)">
                                <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                            </div>
                            <div class="text-danger" *ngIf="showError == true && form.controls['toDate'].hasError('required')">*Please select To</div>
                        </div>
                    </div>
                </div>
    
                <div class="col-md-6 col-lg-6 ">
                    <div class="form-group">
                        <label>GPA </label>
                        <input type="text" name="" class="form-control" placeholder="4 GPA" formControlName="gpa" (keypress)="preventNumbers($event)">
                        <div class="text-danger" *ngIf="form.controls['gpa'].hasError('required') && showError">
                            *Please enter GPA.
                        </div>
                        <div class="text-danger" *ngIf="showGPAError">
                            *Please enter a value between 0 and 4.
                        </div>
                    </div>
                </div>
    
                <div class="col-md-12 col-lg-12 ">
                    <div class="form-group">
                        <label> Description </label>
                        <textarea type="text" class="form-control" placeholder="Enter description" formControlName="description" maxlength="250"></textarea>
                        <div class="text-danger" *ngIf="form.controls['description'].hasError('required') && showError">
                            *Please enter description.
                        </div>
                        <div class="text-danger" *ngIf="form.controls['description'].hasError('minlength') && showError">
                            *Minimum length of 3 characters.
                        </div>
                        <div class="text-danger" *ngIf="form.controls['description'].hasError('maxlength') && showError">
                            *Minimum length of 250 characters.
                        </div>
                    </div>
                </div>
    
                <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheckBox1" formControlName="isPursuing" [value]="1" [checked]="form.value.isPursuing == 1" (change)="form.value.isPursuing = 1;isDisabled($event)">
                            <label class="custom-control-label" for="customCheckBox1"> I am currently pursuing this course/degree </label>
                        </div>
                        <div class="text-danger" *ngIf="form.controls['isPursuing'].hasError('required') && showError">
                            *Please accept Conditions.
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="form-group">
                <input type="submit" value="Save"  class="commonBtn width50 mt-4">
            </div>
        </form>
    </div>